import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { MembersService } from 'src/app/members/members.service';
import { ChildService } from '../services/child.service';
import { Child } from '../../shared/interfaces/child.interface';
import { until } from 'protractor';

@Component({
  selector: 'app-children-form',
  templateUrl: './children-form.component.html',
  styleUrls: ['./children-form.component.css'],
})
export class ChildrenFormComponent implements OnInit {
  id: number;
  mothers: any;
  fathers: any;
  form: FormGroup;
  optionsFather: any;
  filteredOptions: Observable<string[]>;
  fatherIsMember = new FormControl(true);
  motherIsMember = new FormControl(true);

  constructor(
    private membersService: MembersService,
    private childService: ChildService,
    private toastr: ToastrService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.minLength(5), Validators.required]),
      birth_date: new FormControl('', [Validators.required]),
      gender: new FormControl('', [Validators.required]),
      father_name: new FormControl('', [Validators.required]),
      father_id: new FormControl('', []),
      mother_name: new FormControl('', [Validators.minLength(5), Validators.required]),
      mother_id: new FormControl('', [Validators.minLength(5), Validators.required]),
      phone: new FormControl('', [Validators.minLength(5), Validators.required]),
    });

    this.activeRoute.params.subscribe((params) => {
      if (params.id) {
        this.id = params.id;
        this.getChildByIdAndSetInForm(params.id);
      }
    });

    this.form.controls['father_name'].valueChanges.subscribe((val) => {
      if (this.fatherIsMember.value) {
        this.filterOptions(val, 'M');
      }
    });
    this.form.controls['mother_name'].valueChanges.subscribe((val) => {
      if (this.motherIsMember.value) {
        this.filterOptions(val, 'F');
      }
    });

    this.fatherIsMember.valueChanges.subscribe((value: boolean) => {
      if (value) {
        this.form.controls['father_id'].setValidators([Validators.required, Validators.minLength(1)]);
        this.form.controls['father_id'].setValue('');
      } else {
        this.form.controls['father_id'].setValue('');
        this.form.controls['father_id'].clearValidators();
      }
      this.form.controls['father_id'].updateValueAndValidity();
    });

    this.motherIsMember.valueChanges.subscribe((value: boolean) => {
      if (value) {
        this.form.controls['mother_id'].setValidators([Validators.required, Validators.minLength(1)]);
        this.form.controls['mother_id'].setValue('');
      } else {
        this.form.controls['mother_id'].setValue('');
        this.form.controls['mother_id'].clearValidators();
      }
      this.form.controls['mother_id'].updateValueAndValidity();
    });
  }

  errors() {
    console.log(this.form);
  }

  filterOptions(name: string, gender: string): void {
    this.membersService
      .getFather(name, gender)
      .then((res) => {
        if (gender == 'M') {
          this.fathers = res;
        } else {
          this.mothers = res;
        }
      })
      .catch((err) => {
        this.toastr.error(err.error.message);
      });
  }

  setId(value: any, controlName: string) {
    this.form.controls[controlName].setValue(value);
  }

  getChildByIdAndSetInForm(id: number) {
    this.childService.getById(id).then((res: Child) => {
      const { name, birth_date, gender, phone, father_id, mother_id, father_name, mother_name } = res[0];
      const dateFormatted = birth_date.split('T')[0];

      father_id ? this.fatherIsMember.setValue(true) : this.fatherIsMember.setValue(false);
      mother_id ? this.motherIsMember.setValue(true) : this.motherIsMember.setValue(false);
      this.form.setValue({
        name,
        birth_date: dateFormatted,
        gender,
        phone,
        father_id,
        father_name,
        mother_id,
        mother_name,
      });
    });
  }

  save() {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.childService
      .addChild(this.form.value)
      .then((res) => {
        this.toastr.success(res.message);
        this.router.navigateByUrl('/crianca');
      })
      .catch((err) => {
        this.toastr.error('Falha ao cadastrar criança');
      });
  }

  update() {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.childService
      .updateChild(this.form.value, this.id)
      .then((res) => {
        this.toastr.success(res.message);
        this.router.navigateByUrl('/crianca');
      })
      .catch((err) => {
        this.toastr.error('Falha ao salvar alteração da  criança');
      });
  }
}
